<template>
    <div id="new" class="ui segment">
        <h1 class="ui header">
            <!-- 新增號碼區間 -->
            {{ $t('ui.page_titles.new_provider_partition') }}
        </h1>
        <div class="ui divider"></div>
        <div class="ui form">
            <div class="ui grid" style="margin-top:0;margin-bottom:0">
                <div class="six wide red field" data-column="name">
                    <label>{{ $t('models.attributes.partitions.name') }}</label>
                    <input type="text" v-model="partition.name">
                </div>
                <div class="five wide red field" data-column="numbers_from">
                    <label>{{ $t('models.attributes.partitions.numbers_from') }}</label>
                    <input @change="$forceUpdate()" type="text" v-model="partition.numbers_from">
                </div>
                <div class="five wide red field" data-column="numbers_to">
                    <label>{{ $t('models.attributes.partitions.numbers_to') }}</label>
                    <input @change="$forceUpdate()" type="text" v-model="partition.numbers_to">
                </div>

                <div class="eight wide red field" data-column="customer_identity">
                    <label>
                        {{ $t('models.attributes.partitions.customer') }}
                        <i
                            class="pointer remove circle red icon clear_dropdown"
                            v-if="partition.customer_identity"
                            @click="clear_dropdown('.ui.dropdown.customer_identity')">
                        </i>
                    </label>
                    <select @change="$forceUpdate()" v-if="current_store.customers" class="ui dropdown customer_identity" v-dropdown v-model="partition.customer_identity">
                        <option value="">
                            {{ $t('ui.general.please_select') }}，
                            {{ $t('ui.pages.partitions.if_use_it_yourself_do_not_write') }}
                        </option>
                        <option v-for="customer in current_store.customers" :value="customer.identity">{{ customer.company_short_name || customer.tax }}</option>
                    </select>
                    <div v-else class="ui inline active loader"></div>
                </div>
                <div class="eight wide red field">
                    <label>{{ $t('models.attributes.partitions.contracts') }}</label>
                    <select @change="$forceUpdate()" class="ui dropdown partition_type" v-if="current_customer" v-dropdown v-model="partition.contract_ids" multiple>
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="contract in current_customer.contracts" :value="contract.identity">{{ contract.name }}</option>
                    </select>
                </div>
                <div class="eight wide red field" data-column="material_identity">
                    <label>
                        {{ $t('models.attributes.partitions.material') }}
                        <i
                            class="pointer remove circle red icon clear_dropdown"
                            v-if="partition.material_identity"
                            @click="clear_dropdown('.ui.dropdown.material_identity')">
                        </i>
                    </label>
                    <select @change="$forceUpdate()" v-if="current_store.customers" class="ui dropdown material_identity" v-dropdown v-model="partition.material_identity">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="material in current_store.materials" :value="material.identity">{{ material.name }}</option>
                    </select>
                    <div v-else class="ui inline active loader"></div>
                </div>

                <div class="eight wide red field">
                    <label>
                        {{ $t('models.attributes.partitions.label_type') }}
                        <i
                            class="pointer remove circle red icon clear_dropdown"
                            v-if="partition.label_type"
                            @click="clear_dropdown('.ui.dropdown.label_type')">
                        </i>
                    </label>
                    <select @change="$forceUpdate()" class="ui dropdown label_type" v-dropdown v-model="partition.label_type">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option value="Label::Default">TW568預設</option>
                        <option value="Label::ByExpress" v-if="$store.state.provider.node.code == 'BY'">博宇速運</option>
                        <option value="Label::ChangQing" v-if="$store.state.provider.node.code == 'CQF'">長慶運通</option>
                        <option value="Label::FlyCargo" v-if="$store.state.provider.node.code == 'FR'">飛樂航空</option>
                        <option value="Label::HCT">新竹物流</option>
                        <option value="Label::TCat">統一速達</option>
                        <option value="Label::Pelican">宅配通</option>
                        <option value="Label::Presco">統一數網(7-ELEVEn)</option>
                        <option value="Label::FamilyMart">日翊文化(全家)</option>
                    </select>
                </div>

                <div class="eight wide red field">
                    <label>
                        {{ $t('models.attributes.partitions.numbers_rule') }}
                        <i
                            class="pointer remove circle red icon clear_dropdown"
                            v-if="partition.numbers_rule"
                            @click="clear_dropdown('.ui.dropdown.numbers_rule')">
                        </i>
                    </label>
                    <select @change="$forceUpdate()" class="ui dropdown numbers_rule" v-dropdown v-model="partition.numbers_rule">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option value="tcat_numbers_rule">黑貓檢查碼</option>
                        <option value="hct_numbers_rule">新竹檢查碼</option>
                        <option value="pelican_numbers_rule">宅配通檢查碼</option>
                    </select>
                </div>

                <div class="eight wide red field">
                    <label>
                        {{ $t('models.attributes.partitions.partition_type') }}
                        <i
                            class="pointer remove circle red icon clear_dropdown"
                            v-if="partition.partition_type"
                            @click="clear_dropdown('.ui.dropdown.partition_type')">
                        </i>
                    </label>
                    <select @change="$forceUpdate()" class="ui dropdown partition_type" v-dropdown v-model="partition.partition_type">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option value="Manual">手動取號</option>
                        <option value="Auto">自動取號</option>
                        <option value="Group">區間群組</option>
                    </select>
                </div>

                <div class="sixteen wide red field" data-column="note">
                    <label>{{ $t('models.attributes.partitions.note') }}</label>
                    <textarea v-model="partition.note" rows="4"></textarea>
                </div>
            </div>

            <div class="ui negative message" v-for="(trial_error, key, index) in trial_errors">
                <h3>{{ $t("models.attributes.partitions." + key) }}</h3>
                <ul>
                    <li v-for="error in trial_error">{{ error }}</li>
                </ul>
            </div>

            <div class="ui positive message" v-if="trialed_partition && !trial_errors && !is_trialling">
                <h2>
                    <!-- 驗證結果 -->
                    {{ $t('ui.general.verify') }}
                    {{ $t('ui.general.result') }}
                </h2>
                <span style="font-weight: bold;font-size: 1.1em;">
                    <!-- 起始： -->
                    {{ $t('models.attributes.partitions.numbers_from') }}：
                </span>
                {{ trialed_partition.numbers_from }}<br>

                <span style="font-weight: bold;font-size: 1.1em;">
                    <!-- 結尾： -->
                    {{ $t('models.attributes.partitions.numbers_to') }}：
                </span>
                {{ trialed_partition.numbers_to }}<br>

                <span style="font-weight: bold;font-size: 1.1em;">
                    <!-- 總數量： -->
                    {{ $t('ui.pages.partitions.total_amount') }}：
                </span>
                {{ number_with_commas(trialed_partition.numbers_amount) }}<br>

                <span style="font-weight: bold;font-size: 1.1em;">
                    <!-- 可用數量： -->
                    {{ $t('ui.pages.partitions.available_quantity') }}：
                </span>
                {{ number_with_commas(trialed_partition.remaining_numbers) }}
            </div>

            <div class="ui divider"></div>

            <div class="ui buttons">
                <router-link :to="{name: 'provider_partitions'}" class="ui button">
                    {{ $t('ui.general.back') }}
                </router-link>
                <div class="or"></div>
                <a href="#" v-if="!is_trialling" @click.prevent="trial_partition()" class="ui orange button">
                    <!-- 驗證 -->
                    {{ $t('ui.general.verify') }}
                </a>
                <a href="#" v-else class="ui orange button">
                    <!-- 驗證中... -->
                    {{ $t('ui.general.verifying') }}...
                </a>
                <div class="or"></div>
                <a href="#" v-if="!is_loading" @click.prevent="create_partition()" class="ui blue button">
                    <!-- 建立 -->
                    {{ $t('ui.general.create') }}
                </a>
                <a href="#" v-else class="ui blue button">
                    <!-- 建立中... -->
                    {{ $t('ui.general.creating') }}...
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import FileUploader from "@toolbox/file_uploader/main.vue"
import Validator from '@toolbox/validator/main.js';
import ErrorBox from '@toolbox/error_box/main.vue';

export default {
    name: "NewPartition",
    mixins: [
        Validator
    ],
    props: {
    },
    data() {
        return {
            is_loading: false,
            partition: {
                contract_ids: [],
                partition_type: "Manual",
                label_type: "Label::Default"
            },
            is_trialling: false,
            trialed_partition: null,
            trial_errors: null
        }
    },
    mounted() {
    },
    methods: {
        number_with_commas(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        clear_dropdown(selector = "") {
            this.partition.customer_identity = null;
            $(selector).dropdown('clear');
        },
        string_rjust(input, width, padding) {
            let text = String(input);
            if (text.length <= width) {
                return String(input).rjust(width, padding);
            } else {
                return "".rjust(width, "-");
            }
        },
        trial_partition() {
            this.trial_errors = null;
            if (this.valid()) {
                this.is_trialling = true;

                let params = this.partition;
                let url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_partitions_trial).parse();

                return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        console.log(response);
                        if (response.data.status == "success") {
                            this.trialed_partition = response.data.partition;
                            this.is_trialling = false;
                        } else {
                            this.trial_errors = response.data.errors;
                            // "驗證號碼區間失敗"
                            this.$noty.error(
                                this.$t('ui.notifications.error.verify__name', {
                                    name: this.$t('models.partitions'),
                                })
                            );
                            this.is_trialling = false;
                            Promise.reject();
                        }
                    })
                    .catch(error => {
                        // this.$noty.error("驗證號碼區間錯誤");
                        this.$noty.error(
                            this.$t('ui.notifications.error.verify__name', {
                                name: this.$t('models.partitions'),
                            })
                        );
                        this.is_trialling = false;
                    });
            }
        },
        async create_partition() {
            if (this.valid()) {
                await this.trial_partition();
                this.is_loading = true;

                let params = this.partition;
                let url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_partitions_create).parse();

                await axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.is_loading = false;
                            this.$store.commit('provider/partitions_module/add_partition', response.data.partition)
                            this.$bus.$emit("out_of_date", this.$store.state.instance_identity, "partitions");
                            this.$router.push('/provider/partitions');
                        } else {
                            // this.$noty.error("建立號碼區間失敗");
                            this.$noty.error(
                                this.$t('ui.notifications.error.create__name', {
                                    name: this.$t('models.partitions')
                                })
                            );
                            this.is_loading = false;
                        }
                    })
                    .catch(error => {
                        // this.$noty.error("建立號碼區間失敗");
                        this.$noty.error(
                            this.$t('ui.notifications.error.create__name', {
                                name: this.$t('models.partitions')
                            })
                        );
                        this.is_loading = false;
                    });
            }
        },
    },
    validator: {
        target: "partition",
        localize_key: "partitions",
        input_alert: true,
        attributes: [
            {
                name: "name",
                required: true
            },
            {
                name: "customer_identity",
                required: false
            },
            {
                name: "material_identity",
                required: true
            },
            {
                name: "numbers_from",
                required: true
            },
            {
                name: "numbers_to",
                required: true
            },
            {
                name: "note",
                required: false
            }
        ]
    },
    computed: {
        current_store: (instance) => instance.$store.state.provider.partitions_module,
        current_customer() {
            return _.findLast(this.current_store.customers, customer => customer.identity == this.partition.customer_identity)
        }
    },
    components: {
        FileUploader,
        ErrorBox,
    }
}
</script>

<style lang="scss">

</style>
